import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@atlassian/jira-skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint, type Cleanup, type PreloadPriority } from '@atlassian/react-loosely-lazy';
import type { IssueTableGadgetEditData } from '../../../types.tsx';

const LazyVotedIssuesGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetEditData>>
>(() => import(/* webpackChunkName: "async-react-voted-issues-gadget-edit" */ './main'));

export const VotedIssuesGadgetEdit = (
	props: ReactGadgetProps<IssueTableGadgetEditData>,
): React.JSX.Element => (
	<Placeholder name="voted-issues-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyVotedIssuesGadgetEdit {...props} />
	</Placeholder>
);

export const { preload }: { preload: (priority?: PreloadPriority) => Cleanup } =
	LazyVotedIssuesGadgetEdit;
